<template>
    <b-badge :variant="c_status.variant">{{c_status.text}}</b-badge>
</template>

<script>
import {BBadge} from 'bootstrap-vue'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:Object
    },
    computed:{
        c_status(){
            if(this.row?.AgreementStep == 0){
                if(this.row?.IsLastAnswerDateExpired == false){
                    if(this.row?.HasActiveChangeRequest) return { variant:'info',text:'Değişiklik Talebi Yapıldı' }
                    else if(this.row?.CustomerResponseProcessCompleted) return { variant:'secondary',text:'Teklif Onayı Bekleniyor' }
                    else return { variant:'success',text:'Teklif Gönderildi' }
                }else return { variant:'danger',text:'Teklif Süresi Geçti' }
            }else if(this.row?.AgreementStep == 1){
                if(this.row?.HasAgreementInformation == false){
                    return { variant:'secondary',text:'Sözleşme Bekleniyor' }
                }else if(this.row?.HasAgreementInformation == true && this.row?.AgreementInformationStatus == 0){
                    return { variant:'primary',text:'Sözleşme Gönderildi' }
                }else if(this.row?.HasAgreementInformation == true && this.row?.AgreementInformationStatus == 1){
                    return { variant:'success',text:'Sözleşme Onaylandı' }
                }else if(this.row?.HasAgreementInformation == true && this.row?.AgreementInformationStatus == 2){
                    return { variant:'danger',text:'Sözleşme Reddedildi' }
                }else{
                    return { variant:'secondary',text:'Sözleşme Bekleniyor' }
                }
            }else{
                return { variant:'dark',text:'İşlem Yok' }
            }
        }
    }
}
</script>

<style>

</style>